<ul id="app-sidebar-menu" class="layout-menu">
  <li app-menuitem *ngFor="let item of model; let i = index" [item]="item" [index]="i" [root]="true"></li>
</ul>
<ng-content></ng-content>
